<template>
  <label
    v-for="(option, index) in options"
    :key="index"
    type="button"
    class="flex items-center min-w-[238px] h-80 px-16 border border-n-gray-40 rounded-20"
    :data-checked="checked.includes(option.value)">
    <div class="flex items-center gap-8 w-full select-none">
      <SvgIcon
        :name="option.icon"
        size="32"
        type="country"
        class="shrink-0"/>
      {{ $t(option.label) }}
    </div>
    <CheckboxBox
      v-model="checked"
      :value="option.value"/>
  </label>
</template>

<script setup lang="ts">
import { FormKitFrameworkContext } from '@formkit/core';
import { CheckboxTileOption } from '@formkit/inputs';
import { computed, ref, watch } from 'vue';

const props = defineProps<{ context: FormKitFrameworkContext<any> }>();
const options = computed<CheckboxTileOption>(() => props.context.options as unknown as CheckboxTileOption ?? []);

const checked = ref(props.context.value || []);
watch(checked, (newValue) => {
  props.context!.node.input(newValue);
});
</script>

<style lang="scss">
[data-type="CheckboxTile"] {
  & > .formkit-wrapper {
    @apply max-w-full;

    & > .formkit-inner {
      @apply flex-wrap gap-20 shadow-none;
    }
  }
}
</style>
